import { render } from "./figthDie.vue?vue&type=template&id=d5842f7a&scoped=true"
import script from "./figthDie.vue?vue&type=script&lang=js"
export * from "./figthDie.vue?vue&type=script&lang=js"

import "./figthDie.vue?vue&type=style&index=0&id=d5842f7a&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5842f7a"]])

export default __exports__